import * as Sentry from '@sentry/browser'
import { messageAgent } from 'src/api/node/requests'
import {
  selectCustomerProfile,
  selectCustomerIBuyerName
} from 'src/store/selectors/customerProfile'
import { selectHomeId } from 'src/store/selectors/home/'
import { selectSponsorshipId } from 'src/store/selectors/sponsorship'
import { selectUserIdPair } from 'src/store/selectors/layout'

import { SYSTEM_REQUEST } from 'src/constants/messages'

import {
  SEND_INSTANT_OFFER_REQUEST,
  SEND_INSTANT_OFFER_SUCCESS,
  SEND_INSTANT_OFFER_FAILURE
} from './actionTypes'

export const sendInstantOfferRequest = () => async (dispatch, getState) => {
  const state = getState()
  const customerProfile = selectCustomerProfile(state)
  const homeId = selectHomeId(state)
  const ibuyerName = selectCustomerIBuyerName(state)

  dispatch({ type: SEND_INSTANT_OFFER_REQUEST })

  try {
    const options = {
      topic: SYSTEM_REQUEST.instantOfferTopic.defaultMessage,
      message: ibuyerName,
      agentId: customerProfile.legacyRef,
      sponsorId: selectSponsorshipId(state),
      clientId: selectUserIdPair(state).legacyId
    }

    await messageAgent(homeId, options)

    dispatch({ type: SEND_INSTANT_OFFER_SUCCESS })
  } catch (error) {
    Sentry.captureException(error)

    dispatch({ type: SEND_INSTANT_OFFER_FAILURE })
  }
}
